import { render, staticRenderFns } from "./ComplianceDetails.vue?vue&type=template&id=e94eaab2&scoped=true"
import script from "./ComplianceDetails.vue?vue&type=script&lang=js"
export * from "./ComplianceDetails.vue?vue&type=script&lang=js"
import style0 from "./ComplianceDetails.vue?vue&type=style&index=0&id=e94eaab2&prod&lang=css"
import style1 from "./ComplianceDetails.vue?vue&type=style&index=1&id=e94eaab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94eaab2",
  null
  
)

export default component.exports